import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { editCategory } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { CategoryProvider } from '../../../../CategoryContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import CategoryEditContent from '../../../../components/Dashboard/Subscription/CategoryEditContent'


const SingleCategoryEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Categories.List.EditCategory.Title' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editCategory.image}
               description={intl.formatMessage({ id: 'Categories.List.EditCategory.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <CategoryProvider pageAction={'edit'} cid={id}
                                      handleNotificationCall={handleNotificationCall}>
                      <CategoryEditContent pageTitle={<FormattedMessage id='Categories.List.EditCategory.Title'/>}/>
                    </CategoryProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.subscription.category.list}/>
      }
    </>
  )
}

export default SingleCategoryEdit

